import { useMemo } from 'react'

import useTranslation from 'next-translate/useTranslation'

import GamesLibrary from '~/gameConfigs/GamesLibrary'
import { VersionedGame } from '~/graphql/generated/schema'

// used in game progress query
export const useVersionedGames = (): VersionedGame[] => {
  const { lang } = useTranslation()

  const filteredGameSlugs = useMemo(() => {
    const gameSlugsWithLanguageFilter = GamesLibrary.filter((game) =>
      game.languages.includes((lang as SupportedLangType) || 'en'),
    ).map((game) => ({
      gameSlug: game.slug,
      gameVersion: game.version,
    }))
    return gameSlugsWithLanguageFilter
  }, [lang])

  return filteredGameSlugs
}

// this hook is used for games-rank & games-growth list
export const useGameListForGameRank = (): {
  availableGames: GameConfig[]
  versionedGames: VersionedGame[]
} => {
  const data = useMemo(() => {
    return {
      availableGames: GamesLibrary,
      versionedGames: GamesLibrary.map((g) => ({ gameSlug: g.slug, gameVersion: g.version })),
    }
  }, [])
  return data // do not filter anything from this list, let backend decide which games to show
}
